<template>
  <el-card>
    <el-table
      border
      size="mini"
      :cell-class-name="getCellClass"
      :data="[user]"
    >
      <el-table-column label="" width="160">
        <template v-slot="scope" >
          <el-button
            class="scales-settings-visibility"
            size="mini"
            :icon="visible ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
            @click="toggleBlockVisibility"
          >
            {{ visible ? 'Свернуть': 'Развернуть' }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column  label="Позиция" prop="position"></el-table-column>
      <el-table-column width="60" label="Цех" prop="workshop"></el-table-column>
      <el-table-column label="Дирекция" prop="direction"></el-table-column>
      <el-table-column width="80"  label="Локация" prop="location"></el-table-column>
      <el-table-column width="60" label="Бенд" prop="band" v-if="$canAndRulesPass(currentUser, 'successors.see_band')"></el-table-column>
      <el-table-column label="ФИО сотрудника" prop="full_name" v-slot="scope">
        <div style="display: flex; justify-content: space-between">
          <div>{{scope.row.full_name}}</div>
          <history-modal
            v-if="$canAndRulesPass(currentUser, 'successors.see_history')"
            style=""
            title="История изменений"
            width="70%"
            :method="getUserHistory"
            :params="{  user_id: user.id }"
          >
            <el-button
              slot="reference"
              type="text"
              size="mini"
              icon="fas fa-history"
            >
            </el-button>
          </history-modal>
        </div>
      </el-table-column>
      <el-table-column width="140" label="Риск увольнения" prop="evaluate_risk_dismissal_id">
        <template v-slot="scope">
          <div v-if="evaluations[5] && scope.row.currentCard && scope.row.currentCard.info && scope.row.currentCard.info.evaluate_risk_dismissal_id">
            {{ evaluations[5].find(e => e.id === scope.row.currentCard.info.evaluate_risk_dismissal_id).name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="80" label="Возраст" prop="age" v-if="$canAndRulesPass(user, 'successors.see_age')" ></el-table-column>
      <el-table-column width="120" label="Риск позиции" >
        <template slot="header" slot-scope="scope">
          <div>
            <div>Риск позиции</div>
          </div>

        </template>
        <template v-slot="scope">
          {{$companyConfiguration.settings.getEnum('successor_position_risks')[scope.row.position_risk]}}
        </template>
      </el-table-column>
    </el-table>

    <div v-if="visible" style="margin-top: 20px">
      <successors-table
        :user="user"
        @new-user-position-risk="updateUserPositionRisk"
      ></successors-table>
    </div>
  </el-card>
</template>

<script>

import requestSender from "@/api/base/requestSender";
import SuccessorsTable from "@/componentsCompany/smz/successors/SuccessorsTable.vue";
import ClickToEdit from "@/components/ClickToEdit.vue";
import HistoryModal from "@/components/HistoryModal.vue";
import {mapGetters} from "vuex";


export default {
  name: "successor-block",
  components: {HistoryModal, ClickToEdit, SuccessorsTable},
  props: {
    user: {type: Object, required: true},
    evaluations: {type: Object, required: true},
  },
  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),
  },


  data() {
    return {
      loading: false,
      visible: false,
    }
  },

  methods: {
    getUserHistory(payload) {
      return requestSender('get', 'successor/get-user-history', payload);
    },
    toggleBlockVisibility(){
      this.visible = !this.visible;
    },
    updateUserPositionRisk(newPositionRisk){
      this.user.position_risk = newPositionRisk;
    },
    getCellClass({row, column, rowIndex, columnIndex}){
      if( column.property === 'evaluate_risk_dismissal_id' ){
        switch (row?.currentCard?.info?.evaluate_risk_dismissal_id){
          case 18:
            return 'successors-table-risk-cell-low';
          case 17:
            return 'successors-table-risk-cell-normal';
          case 16:
            return 'successors-table-risk-cell-high';
        }
        return '';
      }
      if( column.label === 'Риск позиции' ){
        switch (row.position_risk){
          case 1:
            return 'successors-table-risk-cell-low';
          case 2:
            return 'successors-table-risk-cell-normal';
          case 3:
            return 'successors-table-risk-cell-high';
        }
        return '';
      }
      return null;
    },
  },
}
</script>

<style lang="scss">
.successor-data-hint-block{
  table, th, td{
    border: 1px solid black;
    border-collapse: collapse;
  }
  table{
    width: 100%;
  }
  td {
    padding: 5px;
  }
}
</style>